import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Instagram, Facebook } from 'lucide-react';
import { SHOW_INFO, CONTACT_INFO, SOCIAL_LINKS } from '../../data/showData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] border-t border-white/10" data-testid="main-footer">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <h3 className="font-display text-3xl text-[#FFD700] tracking-wider">
              SISTER TAC
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Il musical più irriverente e divertente d'Italia. 
              Una drag queen, tante suore e risate assicurate!
            </p>
            <p className="text-gray-500 text-xs">
              Organizzato da {SHOW_INFO.organization}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-lg">Link Rapidi</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="footer-link text-sm" data-testid="footer-link-home">
                Home
              </Link>
              <a 
                href="/#booking-section" 
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.getElementById('booking-section');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                  else window.location.href = '/#booking-section';
                }}
                className="footer-link text-sm cursor-pointer" 
                data-testid="footer-link-prenota"
              >
                Prenota Biglietti
              </a>
              <Link to="/regalo" className="footer-link text-sm" data-testid="footer-link-regalo">
                Biglietto Regalo
              </Link>
              <Link to="/info" className="footer-link text-sm" data-testid="footer-link-info">
                Info & FAQ
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-lg">Contatti</h4>
            <div className="space-y-3">
              <a 
                href={CONTACT_INFO.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 footer-link text-sm"
                data-testid="footer-whatsapp"
              >
                <Phone className="w-4 h-4 text-[#25D366]" />
                {CONTACT_INFO.whatsappDisplay}
              </a>
              <a 
                href={`mailto:${CONTACT_INFO.email}`}
                className="flex items-center gap-3 footer-link text-sm"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4 text-[#FFD700]" />
                {CONTACT_INFO.email}
              </a>
            </div>
          </div>

          {/* Social Links */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-lg">Seguici</h4>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/sistertac/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#E4405F] transition-colors"
                aria-label="Instagram"
                data-testid="footer-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61587869662399"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#1877F2] transition-colors"
                aria-label="Facebook"
                data-testid="footer-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
            <p className="text-gray-500 text-xs mt-4">
              Condividi l'emozione!
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm text-center md:text-left">
            © {currentYear} {SHOW_INFO.organization}. Tutti i diritti riservati.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-gray-500 text-sm hover:text-[#FFD700] transition-colors" data-testid="footer-privacy">
              Privacy Policy
            </Link>
            <Link to="/cookie" className="text-gray-500 text-sm hover:text-[#FFD700] transition-colors" data-testid="footer-cookie">
              Cookie Policy
            </Link>
            <Link to="/termini" className="text-gray-500 text-sm hover:text-[#FFD700] transition-colors" data-testid="footer-termini">
              Termini
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
